<template>
  <b-container fluid="xl">
    <b-row class="tabviewtable">
      <b-col>
        <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
          <div class="">
            <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
              <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
              <span @click="removeChip('Date')"><i class="pi pi-times"></i>
              </span>
            </div>
            <div class="filter_chip" v-if="filterItemsArray[0]['StatusName'] != ''">
              <span>Status: {{ filterItemsArray[0]["StatusName"] }}</span>
              <span @click="removeChip('StatusName')"><i class="pi pi-times"></i>
              </span>
            </div>
            <div class="filter_chip" v-if="filterItemsArray[0]['FromStore'] != ''">
              <span>From Store: {{ filterItemsArray[0]["FromStore"] }}</span>
              <span @click="removeChip('FromStore')"><i class="pi pi-times"></i>
              </span>
            </div>
            <div class="filter_chip" v-if="filterItemsArray[0]['Code'] !== ''">
              <span>PO code: {{ filterItemsArray[0]["Code"] }}</span>
              <span @click="removeChip('Code')"><i class="pi pi-times"></i>
              </span>
            </div>
          </div>
          <div class="">
            <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
              Clear all
            </button>
          </div>
        </div>
        <div v-if="windowWidth > 545">
          <b-row>
            <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
              <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                  :ClearDateFilter="SearchValue" v-if="FilterLoading">
                  <template v-slot:filterslot>
                    <poGrnFilters @StatusNames="EmitStatus" @StatusIds="EmitStatusId" :removechiptype="removechipvalue"
                      :StatusFilter="StatusFilter" :showFields="false" />
                    <requestFilters @suppliersename="EmitFromStore" @supplierseid="EmitFromStoreId"
                      @updatedcode="Emitcode" :removechiptype="removechipvalue" :itemsList="items" />
                  </template>
                </FilterForm>
              </b-collapse>
            </b-col>
            <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
              <SkeletonTableLoader :columns="headers" :loading="loading" />
              <div v-if="!loading">
                <MasterEmpty :createline="false" v-if="
                  items.length === 0 &&
                  !SearchValue.inputValue &&
                  !SearchValue.fromDate &&
                  !hasData &&
                  !SearchValue.toDate
                " eheader="Request" econtent="Request" eimg="/src/assets/Img/icons/sub-tax.svg" @createNew="" />
                <Tableview v-if="
                  items.length !== 0 ||
                  SearchValue.inputValue ||
                  SearchValue.fromDate ||
                  SearchValue.toDate ||
                  hasData
                " :paginator="false" :value="items" class="p-datatable-gridlines commonstatusclass" :rows="10"
                  dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                  :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                  :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false" :searchbox1="true"
                  @search="SearchBox" :exceldownload="true" :filterbtn="true" :statusFilterBtn="true"
                  :showColumnFilters="false">
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:statusFilterBtn>
                    <div class="filterBtnStatus d-flex align-items-center">
                      <div class="filter_chip1" :class="{ 'selected-chip': item.id === selectedStatus }"
                        v-for="item in filterStatus" :key="item.id" @click="selectStatus(item.id, item.name)">
                        <p>
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                  </template>
                  <template v-slot:filter>
                    <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                      :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                      @click="visible = !visible"></i>
                  </template>
                  <template v-slot:DocDate="{ data }">
                    <p>{{ data.DocDateHR }}</p>
                    <p v-if="data.Status != 2">
                      ({{ waitingtime(data.DocDateHR) }})
                    </p>
                  </template>
                  <template v-slot:Add>
                    <span>
                      <!-- <AddButton @click="IsCreate()" :btnname=" $t('btn.plusaddnew')"></AddButton> -->
                      <!-- <DeliveryTermsCreation :showButton="true" @close="deliverytermstable()" /> -->
                    </span>
                  </template>

                  <template v-slot:Code="{ data }">
                    <p v-if="data.Remarkscheck != 0" class="txt-red">
                      {{ data.DocNo }} (MU)
                    </p>
                    <p v-else>{{ data.DocNo }}</p>
                    <div v-if="data.IsCamp == true">
                      <span class="CampName">(Camp)</span>
                    </div>
                  </template>

                  <template v-slot:status="{ data }">
                    <OrangeStatus name="Pending" v-if="data.Status == '0'" />
                    <OrangeStatus name="Converted To PI" v-if="data.Status == '1'" />
                    <GreenStatus name="Issued" v-if="data.Status == '2'" />
                    <BlueStatus name="Partially Issued" v-if="data.Status == '3'" />
                    <BlueStatus name="Converted to PR" v-if="data.Status == '4'" />
                    <BlueStatus name="Partially Converted to PR" v-if="data.Status == '5'" />

                    <RedStatus name="Closed" v-if="data.Status == '6'" />
                    <div v-if="data.Status == '6'">
                      <span for="">Reason: {{ data?.ClosedReason }}</span>
                    </div>

                    <RedStatus name="Cancelled" v-if="data.Status == '7'" />
                    <div v-if="data.Status == '7'">
                      <span for="">Reason: {{ data?.CancelReason }}</span>
                    </div>

                    <BlueStatus name=" Converted to PO" v-if="data.Status == '8'" />
                    <BlueStatus name="Partially Converted to PO" v-if="data.Status == '9'" />
                    <BlueStatus name=" Converted to GRN" v-if="data.Status == '10'" />
                    <BlueStatus name="Partially Converted to GRN" v-if="data.Status == '11'" />

                    <div v-if="data.IsConvertedRequest == '1'">
                      (<span class="text-success">Converted to Request</span>)
                    </div>

                  </template>
                  <template v-slot:ApprovalStatus="{ data }">
                    <OrangeStatus name="Pending" v-if="data.IsApproved == '0'" />
                    <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                    <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <!-- commented by tharuni for print requirement -->
                    <!-- <span v-if="data.Status !== '2'"> -->
                    <!-- <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" v-if="data.Status != '2'" /> -->
                    <span>
                      <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" />
                    </span>
                  </template>
                  <template v-slot:IssuedSlot="{ data }">
                    <p>{{ data.IssueQty }} / {{ data.PendingQty }}</p>
                  </template>
                  <template v-slot:ItemsSlot="{ data }">
                    <p>{{ data.ItemCount }} / {{ data.ItemQty }}</p>
                  </template>
                </Tableview>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="
              items.length === 0 &&
              !SearchValue.inputValue &&
              !SearchValue.fromDate &&
              !SearchValue.toDate
            " eheader="Request" econtent="Request" eimg="/src/assets/Img/icons/sub-tax.svg" @createNew="" />
            <MobileViewCardHeader @search="SearchBox" :totalRecords="rowsCount" :state="state" v-if="
              items.length !== 0 ||
              SearchValue.inputValue ||
              SearchValue.fromDate ||
              SearchValue.toDate
            ">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item["DocNo"] }}</p>
                      <p class="name">{{ item["FromStoreName"] }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <OrangeStatus name="Pending" v-if="item['Status'] == '0'" />
                        <OrangeStatus name="Converted To PI" v-if="item['Status'] == '1'" />
                        <GreenStatus name="Issued" v-if="item['Status'] == '2'" />
                        <BlueStatus name="Partially Issued" v-if="item['Status'] == '3'" />
                        <BlueStatus name="Converted to PR" v-if="item['Status'] == '4'" />
                        <BlueStatus name="Partially Converted to PR" v-if="item['Status'] == '5'" />
                        <BlueStatus name="Converted to PO" v-if="item['Status'] == '8'" />
                        <BlueStatus name="Partially Converted to PO" v-if="item['Status'] == '9'" />
                        <BlueStatus name="Converted to GRN" v-if="item['Status'] == '10'" />
                        <BlueStatus name="Partially Converted to GRN" v-if="item['Status'] == '11'" />
                        <RedStatus name="Closed" v-if="item['Status'] == '6'" />
                      </div>
                      <!-- commented by tharuni for print requirement -->
                      <!-- <i v-if="item['Status'] !== '2'" class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i> -->
                      <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                    </div>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>

  <Dialog v-model:visible="ObjIRClosePopUp.Visible" modal :header="ObjIRClosePopUp.PopUpHeaderName" :breakpoints="{
    '1980px': '55vw',
    '1440px': '60vw',
    '960px': '70vw',
    '640px': '90vw',
  }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <CustomDropdown :items="TableDropDown.Reasonoption" v-model="ObjIRClosePopUp.ClosedReason"
              @change="ReasonOnChange(ObjIRClosePopUp.ClosedReason)">
            </CustomDropdown>
            <!-- <Textarea :name="ObjIRClosePopUp.TextAareaName" :label="ObjIRClosePopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjIRClosePopUp.TextAareaName" v-model="ObjIRClosePopUp.ClosedReason" /> -->
            <Footer class="p-3" @cancel="ObjIRClosePopUp.Visible = false" @save="SaveClosePO" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="popup.Editmodel" @yes="IsEdit(dataEdit)" @no="popup.Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="popup.Deletemodel" @yes="IsDelete(dataEdit)" @no="popup.Deletemodel = false" />
  <DeletedSuccessfully :visible="popup.deletepop" @ok="closetrigger()" />

  <ClosedSuccessfully :content="ModelPopupDunction.CloseModelTxt" :visible="ModelPopupDunction.CloseSuccessPop"
    @ok="Close()" />

  <CloseConfirmation :Editmodel="ModelPopupDunction.CloseConfirmPop" @yes="UpdateCloseStatus()"
    @no="ModelPopupDunction.CloseConfirmPop = false" :header="ObjIRClosePopUp.ConfirmPopupHeader"
    :content="ObjIRClosePopUp.ConfirmPopupContent" />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

import Table from "../../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../../Service/WithoutStockAffectService";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import FilterForm from "../../../../../../../components/FormComponents/FilterForm.vue";
import moment from "moment";
import requestFilters from "../../../../../../../modules/Inventory/components/Filters/requestFilters.vue";
import poGrnFilters from "../../../../../../../modules/Inventory/components/Filters/poGrnFilters.vue";
import ExportOption from "../../../../../../../components/FormComponents/Export.vue";
import CloseConfirmation from "../../../../../../../components/FormComponents/CancelConfirmation.vue";
import ClosedSuccessfully from "../../../../../../../components/FormComponents/CancelSuccessfully.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import CancelConfirmation from "../../../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../../../components/FormComponents/CancelSuccessfully.vue";
import Textarea from "../../../../../../../components/FormComponents/TextArea.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import StockReasonService from "../../../../../../../modules/Inventory/Service/StockReasonService";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,

    Table,
    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    FilterForm,
    requestFilters,
    ExportOption,
    poGrnFilters,
    ClosedSuccessfully,
    CloseConfirmation,
    CancelConfirmation,
    Footer,
    CancelSuccessfully,
    Textarea,
    CustomDropdown,
    StockReasonService,
  },
  props: {
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const routes = useRoute();
    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.status ?? 0;
    let Type = routes.query.Type;
    const datas = ref();
    const menus = ref();
    const Activevisible = ref(false);
    const rowFocus = ref(false);
    const menu = ref();
    const dataEdit = ref();
    let Id = ref();
    const toast = useToast();
    const router = useRouter();
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    let loading = ref(false);
    const CrystalReportPopup = ref(false);
    let visible = ref(false);

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    const IsPending = ref(false);
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let Cancel = ref(false);
    const route = useRoute();
    let StoreBranchId = String(route.query.BranchId) || 0;
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //
    const ParameterValues = ref({
      Id: 0,
      HospitalId: 0,
      BranchId: 0,
    });

    let StatusFilter = ref({
      StatusFrom: "InBReq",
      Status: true,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 9,
      HeaderTitle: "InBound Request",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("InBound Request");
    let ExportOption = ref("");

    let dataValue = {
      Id: "",
      status: "",
    };

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    let filterItems = ref({
      Date: "",
      FromStore: "",
      fromstoreId: "",
      Code: "",
      StatusIds: "",
      StatusName: "",
    });

    let emitedfilterItems = ref({
      FromStore: "",
      fromstoreId: "",
      Code: "",
      StatusIds: "",
      StatusName: "",
    });

    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        StoreId = dataValue.Id;
        status = dataValue.status;
        IsShow();
      }
    });

    const popup = ref({
      Deletemodel: false,
      deletepop: false,
      Editmodel: false,
    });

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let ObjIRClosePopUp = ref({
      Visible: false,
      ClosedReason: "",
      CancelReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjIRClose = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      ClosedReason: "",
      IsApproved: 0,
      StoreId: 0,
      DocNo: "",
      ClosedReasonId: 0,
    });

    const ModelPopupDunction = ref({
      CloseConfirmPop: false,
      CloseModelTxt: "",
      CloseSuccessPop: false,
      cancelmodel: false,
      CancelModelTxt: "",
      CancelSuccessPop: false,
    });

    watch(props, (newValue: any) => {
      debugger;
      console.log("props Changed", newValue.FunctionRights);
      Rights.value.Create = newValue.FunctionRights.Create;
      Rights.value.Update = newValue.FunctionRights.Update;
      Rights.value.Read = newValue.FunctionRights.Read;
      Rights.value.Delete = newValue.FunctionRights.Delete;
      Object.keys(ObjOperationId.value).forEach((key) => {
        if (newValue.FunctionRights[key])
          ObjOperationId.value[key] = newValue.FunctionRights[key];
      });
    });

    const ParamValues = ref({
      requestId: "",
      StockWOTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 1,
      StoreId: StoreId,
      status: status,
      Types: Type,
      StockOutTransTMId: 0,
      EntityId: 0,
      OperationId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      storebranchmapid: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      BranchId: 0,
    });

    const TableDropDown: any = ref({
      Reasonoption: [],
    });

    function toggle(event, data) {
      debugger;
      console.log(event);
      Activevisible.value =
        data.Status != "2" && data.Status != "6" && data.Status != "7"
          ? true
          : false;
      // Cancel.value = ((data.Status == "0" ||data.Status == '3') && data.IsApproved == 1) ? true : false;
      IsPending.value =
        (data.Status == "0" || data.Status == "3") && data.IsApproved == 1
          ? true
          : false;
      datas.value = data;
      menus.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Issue",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IssueOncick(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            //visible: Activevisible,
            command: async () => {
              Print(datas.value);
            },
          },
          {
            label: "Pick List",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              PickListOnclick(datas.value);
            },
          },
          {
            label: "Close",
            icon: "deleteicon pi pi-times-circle",
            visible: IsPending,
            command: async () => {
              CloseIROnClick(datas.value);
            },
            // command: async () => {
            //   PickListOnclick(datas.value);
            // },
          },
          // {
          //   label: "Cancel ",
          //   icon: "deleteicon pi pi-times",
          //   command: async () => {
          //     CancelOnClick(datas.value)
          //   },
          //   visible: Cancel,
          // },
        ],
      },
    ]);

    function IssueOncick(data) {
      debugger;

      console.log(data["DocNo"]);
      let param = "IndirectIssue";
      //commented By Tharuni(For each time request issue - need to be created separate issue)
      // if (data["Status"] == "3") {
      //   ParamValues.value.requestId = data["StockOutCode"];
      //   ParamValues.value.type = 2;
      //   param = "DirectIssue"; //For Partial Request -should be like Issue Edit
      // } else {
      //   ParamValues.value.requestId = data["DocNo"];
      // }

      ParamValues.value.requestId = data["DocNo"]; //Added
      ParamValues.value.StockWOTransTMId = data["StockTransId"];
      ParamValues.value.fromStoreId = data["ToStoreId"];
      ParamValues.value.toStoreId = data["FromStoreId"];
      ParamValues.value.StockOutTransTMId = data["StockOutId"];
      ParamValues.value.EntityId = 3048;
      ParamValues.value.OperationId = 3048001;
      ParamValues.value.FromStoreBrMapId = data["FromStoreBrMapId"];
      ParamValues.value.ToStoreBrMapId = data["ToStoreBrMapId"];
      ParamValues.value.StoreBrMapId = data["StoreBrMapId"];
      ParamValues.value.BranchId = Number(StoreBranchId);

      router.push({
        path: "/Issue",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: param,
        },
      });
    }

    const PickListOnclick = (data) => {
      debugger;
      let param = "IndirectIssue";
      ParamValues.value.EntityId = 3048;
      ParamValues.value.OperationId = 3048001;
      ParamValues.value.requestId = data["DocNo"];
      ParamValues.value.StockWOTransTMId = data["StockTransId"];
      ParamValues.value.fromStoreId = data["ToStoreId"];
      ParamValues.value.toStoreId = data["FromStoreId"];
      ParamValues.value.FromStoreBrMapId = data["FromStoreBrMapId"];
      ParamValues.value.ToStoreBrMapId = data["ToStoreBrMapId"];
      ParamValues.value.StoreBrMapId = data["StoreBrMapId"];
      ParamValues.value.FromStoreBranchId = data["FromStoreBranchId"];
      ParamValues.value.ToStoreBranchId = data["ToStoreBranchId"];
      ParamValues.value.BranchId = Number(routes.query.BranchId ?? 0);

      router.push({
        path: "/PickList",
        query: {
          data: JSON.stringify(ParamValues.value),
          param: param,
        },
      });
    };

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      DocDate: { value: null, matchMode: FilterMatchMode.IN, options: items },
      FromStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      RequestStatusName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      RooName: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };

    const headers = [
      {
        header: t("storetabdetails.inboundrequest.sno"),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        field: "RequestStatusName",
        fieldDisplay: "false",
        header: t("storetabdetails.inboundrequest.Status"),
        slot: "status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundrequest.Code"),
        field: "DocNo",
        fieldDisplay: "false",
        slot: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundrequest.Date"),
        field: "DocDateHR",
        fieldDisplay: "false",
        slot: "DocDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundrequest.FromStore"),
        field: "FromStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      // {
      //   header: t('storetabdetails.inboundrequest.ItemCount'),
      //   field: "ItemCount",
      //   bodyclass: "boldclass right_td",
      //   class: "smallwidth",
      // },
      // {
      //   header: t('storetabdetails.inboundrequest.Qty'),
      //   field: "ItemQty",
      //   bodyclass: "boldclass right_td",
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.inboundrequest.RequestedBy"),
        field: "CreatedByName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.inboundrequest.Items"),
        field: "ItemQty",
        fieldDisplay: "false",
        slot: "ItemsSlot",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },

      // {
      //   header: t('storetabdetails.inboundrequest.IssuedQty'),
      //   field: "IssueQty",
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.inboundrequest.IssuedPending"),
        field: "IssueQty",
        fieldDisplay: "false",
        slot: "IssuedSlot",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      // {
      //   header: t('storetabdetails.inboundrequest.Category'),
      //   field: "CategoryName",
      //   class: "smallwidth",
      // },
      // {
      //   field: "",
      //   fieldDisplay: "false",
      //   header: t('storetabdetails.inboundrequest.PendingSince'),
      //   slot: "waitingsince",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      // },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const IsCreate = () => {
      let permissionResult: any = checkPermission(Rights, "Add");

      if (permissionResult.hasPermission) {
        router.push({
          name: "Request",
          query: { doctype: "1", param: "Request" },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsConfirmEdit(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        popup.value.Editmodel = false;
        popup.value.Deletemodel = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsEdit(data) {
      router.push({
        path: "/Request",
        query: {
          param: "Request",
          doctype: data.DocType,
          Id: data.StockTransId,
        },
      });
    }

    const rowsCount = ref(0);
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    //Get data for TableView
    async function IsShow() {
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "ToStore";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.fromstoreId
          ? filterItems.value.fromstoreId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "IsApproved";
        const columnValue3 = "1";
        debugger;
        let Flag = 1,
          searchOption = "";

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ','))) ";

        if (filterItems.value.StatusIds != "") {
          Condition =
            Condition +
            " and (sm.Status IN (" +
            filterItems.value.StatusIds +
            ")) ";
        } else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          Condition =
            Condition + " and (sm.Status IN (" + buttonFilter.value.Id + ")) ";
        } else if (filterItems.value.StatusIds == "") {
          Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            " and (COALESCE('" +
            usersData.BranchId +
            "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
            usersData.BranchId +
            "', ','))) ";
        }

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTMCustom(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          pageSize,
          pageNum,
          1,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        items.value = response["result"];

        if (items.value.length !== 0) {
          hasData.value = true;
        }

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "ToStore";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.fromstoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.fromstoreId
          ? filterItems.value.fromstoreId
          : "";
        const columnName2 = filterItems.value.Code ? "DocNo" : "";
        const columnValue2 = filterItems.value.Code
          ? filterItems.value.Code
          : "";
        const columnName3 = "IsApproved";
        const columnValue3 = "1";

        let Flag = 1,
          searchOption = "";

        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          " and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ','))) ";

        if (filterItems.value.StatusIds != "") {
          Condition =
            Condition +
            " and (sm.Status IN (" +
            filterItems.value.StatusIds +
            ")) ";
        } else if (
          buttonFilter.value.Name != "" &&
          buttonFilter.value.Name != "All"
        ) {
          Condition =
            Condition + " and (sm.Status IN (" + buttonFilter.value.Id + ")) ";
        } else if (filterItems.value.StatusIds == "") {
          Condition =
            "sm.HospitalId=" +
            usersData.OrganizationId +
            " and (COALESCE('" +
            usersData.BranchId +
            "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
            usersData.BranchId +
            "', ','))) ";
        }

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }

        let response = await commonService.GetStockWOTMCustom(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          0,
          0,
          1,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          Condition
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    // Debounced search for server-side filtering
    function SearchBox(value) {
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
      dataEdit.value = event.data ? event.data : event;
      debugger;
      router.push({
        path: "/InboundRequestDetails",
        query: {
          stocktransid: event.data
            ? event.data.StockTransId
            : event.StockTransId,
        },
      });
      debugger;
    }

    //Delete Values in Table
    const IsDelete = async (data) => {
      try {
        const response = await commonService.DeleteStockWOTM(data.StockTransId);
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          popup.value.Deletemodel = false;
          popup.value.deletepop = true;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Popup-Close
    function closetrigger() {
      popup.value.deletepop = false;
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.StockTransId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
      ParameterValues.value.BranchId = ObjData.ToStoreBranchId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    const EmitFromStore = (data) => {
      emitedfilterItems.value.FromStore = data;
    };

    const EmitFromStoreId = (data) => {
      emitedfilterItems.value.fromstoreId = data;
    };

    const Emitcode = (data) => {
      emitedfilterItems.value.Code = data;
    };

    const EmitStatus = (data) => {
      emitedfilterItems.value.StatusName = data;
    };

    const EmitStatusId = (data) => {
      emitedfilterItems.value.StatusIds = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      filterItems.value.FromStore = emitedfilterItems.value.FromStore;
      filterItems.value.fromstoreId = emitedfilterItems.value.fromstoreId;
      filterItems.value.Code = emitedfilterItems.value.Code;
      filterItems.value.StatusIds = emitedfilterItems.value.StatusIds;
      filterItems.value.StatusName = emitedfilterItems.value.StatusName;
      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 3;
      filterItems.value.fromstoreId = "";
      filterItems.value.Code = "";
      filterItems.value.StatusIds = "";
      emitedfilterItems.value.StatusName = "";
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "Code") {
        removechipvalue.value = 1;
      } else if (data == "FromStore") {
        filterItems.value.fromstoreId = "";
        removechipvalue.value = 2;
      } else if (data == "StatusName") {
        filterItems.value.StatusIds = "";
        removechipvalue.value = 3;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };

    const waitingtime = (targetDate) => {
      // const currentDate = new Date();
      // const differenceInTime = Math.abs(
      //   currentDate.getTime() - new Date(targetDate).getTime()
      // );
      // console.log(differenceInTime);
      // const differenceInDays = Math.floor(
      //   differenceInTime / (1000 * 3600 * 24)
      // );
      // return `${differenceInDays} days`;
      const currentDate = new Date().getTime(); // Convert Date to number (timestamp)
      const targetDateTime = new Date(targetDate).getTime(); // Convert Date to number (timestamp)
      const differenceInTime = Math.abs(currentDate - targetDateTime);

      const differenceInDays = Math.floor(
        differenceInTime / (1000 * 3600 * 24)
      );
      const differenceInMonths = Math.floor(differenceInDays / 30);
      const differenceInYears = Math.floor(differenceInDays / 365);

      const years =
        differenceInYears > 0
          ? `${differenceInYears} Year${differenceInYears > 1 ? "s" : ""}`
          : "";
      const months =
        differenceInMonths % 12 > 0
          ? `${differenceInMonths % 12} Month${differenceInMonths % 12 > 1 ? "s" : ""
          }`
          : "";
      const days =
        differenceInDays % 30 > 0
          ? `${differenceInDays % 30} Day${differenceInDays % 30 > 1 ? "s" : ""
          }`
          : "";

      // If the difference is exactly 0 days, return "0 days"
      if (differenceInDays === 0) {
        return "0 Day";
      }

      return `${years} ${months} ${days}`.trim();
    };
    function CloseIROnClick(data) {
      debugger;

      ObjIRClosePopUp.value.PopUpHeaderName = "Close Inbound Request";
      ObjIRClosePopUp.value.TextAareaName = "Enter Reason";
      ObjIRClosePopUp.value.ClosedReason = "";

      GetListByReason();

      ObjIRClosePopUp.value.Visible = true;

      ObjIRClose.value.EntityId = data.EntityId;
      ObjIRClose.value.EntityOperationId = 3047006;
      ObjIRClose.value.DeptRoleId = rolesData.DeptRoleMapId;
      ObjIRClose.value.Id = data.StockTransId;
      ObjIRClose.value.Status = "6";
      ObjIRClose.value.IsApproved = 0;
      ObjIRClose.value.CreatedBy = usersData.UserId;
      ObjIRClose.value.BranchId = data.BranchId;
      ObjIRClose.value.HospitalId = data.HospitalId;
      ObjIRClose.value.StoreId = data.StoreId;
      ObjIRClose.value.DocNo = data.DocNo;

      ObjIRClosePopUp.value.ConfirmPopupHeader = t("confirmation.confirmclose");
      ObjIRClosePopUp.value.ConfirmPopupContent = t(
        "confirmation.Doyouwanttoclose"
      );
    }

    function SaveClosePO() {
      debugger;
      if (ObjIRClosePopUp.value.ClosedReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.CloseConfirmPop = true;
      }
    }

    async function UpdateCloseStatus() {
      debugger;
      try {
        ObjIRClose.value.ClosedReason = ObjIRClosePopUp.value.ClosedReason;
        const response = await commonService.UpdateCloseStatus(
          ObjIRClose.value
        );
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          ModelPopupDunction.value.CloseConfirmPop = false;
          ModelPopupDunction.value.CloseModelTxt = t(
            "confirmation.IbReqCloseSuccess"
          );
          ModelPopupDunction.value.CloseSuccessPop = true;
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    }
    const Statuschange = async () => {
      debugger;
      try {
        ObjIRClose.value.ClosedReason = ObjIRClosePopUp.value.ClosedReason;
        const response = await commonService.StockWOOutStatusChanged(
          ObjIRClose.value
        );
        let message = response["ErrorInfo"].ErrorCode;
        if (message == null) {
          ModelPopupDunction.value.CloseConfirmPop = false;
          ModelPopupDunction.value.CloseModelTxt = t(
            "confirmation.IbReqCancelSuccess"
          );
          ModelPopupDunction.value.CloseSuccessPop = true;
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    };
    function Close() {
      ModelPopupDunction.value.CloseSuccessPop = false;
      ModelPopupDunction.value.CloseConfirmPop = false;
      ObjIRClosePopUp.value.Visible = false;
      // router.back();
      IsShow();
    }
    const filterStatus = [
      { id: 10, name: "All" },
      { id: 2, name: "Issued" },
      { id: 0, name: "Pending" },
      { id: 3, name: " Partially Issued" },
    ];
    const selectedStatus = ref(10);
    let buttonFilter = ref({
      Id: 0,
      Name: "",
    });
    const hasData = ref(false);
    const selectStatus = (id, name) => {
      debugger;
      selectedStatus.value = id;
      buttonFilter.value.Id = id;
      buttonFilter.value.Name = name;
      if (id != 10) {
        StatusFilter.value.Status = false;
      } else {
        StatusFilter.value.Status = true;
      }
      IsShow();
    };
    async function GetListByReason() {
      debugger;
      try {
        const dataresponse = await StockReasonService.getlistdata();

        TableDropDown.value.Reasonoption = dataresponse["result"].map(
          (item: any) => {
            item.name = item.ReasonName;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
    function ReasonOnChange(value) {
      debugger;

      const selected = TableDropDown.value.Reasonoption.find(
        (item) => item.value === value
      );
      ObjIRClosePopUp.value.ClosedReason = selected ? selected.name : "";
      ObjIRClose.value.ClosedReasonId = selected ? selected.value : 0;
    }
    return {
      ReasonOnChange,
      GetListByReason,
      TableDropDown,
      hasData,
      selectStatus,
      selectedStatus,
      filterStatus,
      RowClick,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      loading,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      menu,
      toggle,
      popup,
      dataEdit,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      IssueOncick,
      rowsCount,
      state,
      itemListed,
      menus,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitFromStore,
      EmitFromStoreId,
      Emitcode,
      EmitStatus,
      EmitStatusId,
      removeChip,
      removechipvalue,
      SearchBox,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ShowRows,
      windowWidth,
      visible,
      waitingtime,
      StatusFilter,
      PickListOnclick,
      ObjIRClosePopUp,
      SaveClosePO,
      ModelPopupDunction,
      Close,
      UpdateCloseStatus,
      Statuschange,
    };
  },
});
</script>

<style lang="scss" scoped>
.table-status {
  padding: 5px 10px;
  background-color: green;
  color: #ffffff;
  border-radius: 5px;
}

.issuebutton {
  padding: 0.2rem 0.5rem !important;
}

.CampName {
  font-size: 14px;
  color: #2a9f0a;
}
</style>
